// extracted by mini-css-extract-plugin
module.exports = {"risks__grid":"styles-module--risks__grid--UI3Ge","risks__card":"styles-module--risks__card--21C0y"};